/**
 * 文件说明:
 *
 * hz 根据后端菜单配置数据获取页面title hooks
 *
 * ----------------------------------------
 * 创建用户: leo
 */

import {useMemo, useEffect} from 'react'
import {useShallowEqualSelector} from 'hooks'
import {useRouteMatch} from 'umi'
import {createMemoizeCache} from 'utils'
import {pathToRegexp} from 'path-to-regexp'

export const getTitleFromTree = createMemoizeCache({
    isEqual(newInputs, lastInputs) {
        return newInputs === lastInputs
    },
    getKey(checkFlatTree, matchPath) {
        return matchPath
    },
    getDeps(checkFlatTree) {
        return checkFlatTree
    },
    getVal(checkFlatTree, matchPath) {
        let title = ''

        for (let i = 0, len = checkFlatTree.length; i < len; i++) {
            const item = checkFlatTree[i]
            if (item.name && pathToRegexp(item.url).test(matchPath)) {
                title = item.name
            }
        }

        return title
    },
})

export const getTopTitleFromTree = createMemoizeCache({
    isEqual(newInputs, lastInputs) {
        return newInputs === lastInputs
    },
    getKey(tree, matchPath) {
        return matchPath
    },
    getDeps(tree) {
        return tree
    },
    getVal(tree, matchPath) {
        let title = ''

        for (let i = 0, len = tree.length; i < len; i++) {
            const item = tree[i]
            if (pathToRegexp(`/${item.slug}`).test(matchPath) && item.name) {
                title = item.name
            }
        }

        return title
    },
})

export function useHzDocTitle(title, defaultTitle) {
    const {checkFlatTree = [], tree = []} = useShallowEqualSelector(({menu}) => ({
        checkFlatTree: menu?.checkFlatTree,
        tree: menu?.tree,
    }))

    const {path} = useRouteMatch()

    const docTitle = useMemo(() => {
        if (typeof title !== 'undefined') {
            return title
        }

        const topTitle = getTopTitleFromTree(tree, path)

        if (topTitle) {
            return topTitle
        }

        return getTitleFromTree(checkFlatTree, path) || defaultTitle
    }, [defaultTitle, checkFlatTree, path, title, tree])

    useEffect(() => {
        if (typeof docTitle === 'string') {
            document.title = docTitle
        }
    }, [docTitle])

    return docTitle
}
